import React from "react";

import "glamor/reset";
import { css, merge, lastChild } from 'glamor';

import { Container, Row, Col, Hidden, Visible } from "react-grid-system";
//import { Image } from "../components/Image/Image";
import ScrollableAnchor from 'react-scrollable-anchor';

import Helmet from "react-helmet";

import circuit from "./circuit.jpg";
import hex from "./hex.jpg";
import art from "./art.jpg";
import logo from "./logo.png";
import chairs from "./chairs.jpg";
import border1 from "./border1.png";
import border2 from "./border2.png";

import Email from "../components/Email";

export default function () {
    css.global('a', {
        color: "#00aa10",
        textDecoration: "none",
    });
    css.global('a:hover', {
        color: "#000"
    });
    css.global('img, div', {
        flexShrink: "0"
    });

    let dsty = css({
        paddingBottom: "4px"
    });

    let lsty = css({
        listStyle: "none",
        paddingLeft: "40px",
        paddingRight: "40px",
        textIndent: "-20px",
        margin: "0px"
    }, lastChild({
        marginBottom: "20px"
    }));

    let arrowbase = css({
        border: "solid #00aa10",
        borderWidth: "0 2px 2px 0",
        display: "inline-block",
        padding: "3px",
        marginBottom: "2px"
    }, {
        "a:hover &": {
            border: "solid #000",
            borderWidth: "0 2px 2px 0"
        }
    });

    let arrowright = <i {...merge({
        transform: "rotate(-45deg)",
        WebkitTransform: "rotate(-45deg)"
    }, arrowbase)}></i>;

    let arrowup = <i {...merge({
        transform: "rotate(-135deg)",
        WebkitTransform: "rotate(-135deg)"
    }, arrowbase)}></i>;

    let arrowdown = <i {...merge({
        transform: "rotate(45deg)",
        WebkitTransform: "rotate(45deg)"
    }, arrowbase)}></i>;

    let imageStyle = css({
        width: "100%",
    });

    return (
        <Container fluid xs sm md lg>
            <Helmet>
                <title>ANQUA - Robotics &#8226; Art &#8226; Construction</title>
                <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
                <meta name="description" content="ANQUA is a Design Workshop specialising in the fields of robotics, art and construction." />

                <meta name="twitter:card" value="summary" />
                <meta name="twitter:image" content={art} /> 
                <meta name="twitter:description" content="ANQUA is a Design Workshop specialising in the fields of robotics, art and construction." />

                <meta property="og:title" content="ANQUA - Robotics &#8226; Art &#8226; Construction" />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://anqua.com/" />
                <meta property="og:image" content={art} />
                <meta property="og:description" content="ANQUA is a Design Workshop specialising in the fields of robotics, art and construction." />

                <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
                <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
                <link rel="manifest" href="/manifest.json" />
                <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#00aa10" />
                <meta name="theme-color" content="#00aa10" />
            </Helmet>
            <ScrollableAnchor id="home">
                <Row align="center" css={{marginTop: "20px"}}>
                    <Col md={7} xs={12}>
                        <img src={logo} {...imageStyle} />
                    </Col>
                    <Col md={5} xs={12} css={{marginTop: "10px"}}>
                        <div {...dsty}><a href="#mission">{arrowdown} Mission</a></div>
                        <div {...dsty}><a href="#capability">{arrowdown} Capability</a></div>
                        <div {...dsty}><a href="#contact">{arrowdown} Contact Us</a></div>
                    </Col>
                </Row>
            </ScrollableAnchor>
            <ScrollableAnchor id="mission">
                <Row align="center" css={{marginTop: "30px"}}>
                    <Col md={5} xs={12} css={{textAlign: "right"}}>
                        <p>
                            ANQUA is a Design Workshop where
                        </p>
                        <ul {...lsty}>
                            <li>Creative thinking</li>
                            <li>Experimentation</li>
                            <li>Research</li>
                            <li>Experience</li>
                            <li>Technical expertise</li>
                        </ul>
                        <p>
                            bring new ideas to life that are 
                        </p>
                        <ul {...lsty}>
                            <li>Innovative</li>
                            <li>Sustainable</li>
                            <li>Useful</li>
                            <li>Beautiful</li>
                        </ul>
                    </Col>
                    <Col md={7} xs={12}>
                        <img src={circuit} {...imageStyle} />
                    </Col>
                </Row>
            </ScrollableAnchor>
            <Row align="center" css={{marginTop: "30px"}}>
                <Col xs={12}>
                    <div css={{width: "100%", overflowX: "hidden"}}>
                        <img src={border1}  {...imageStyle} css={{minWidth: "960px"}}/>
                    </div>
                </Col>
            </Row>
            <ScrollableAnchor id="capability">
                <Row align="center" css={{marginTop: "30px"}}>
                    <Col md={7} xs={12}>
                        <img src={art} {...imageStyle} />
                    </Col>
                    <Col md={5} xs={12}>
                        <p>
                            Anqua is able to produce
                        </p>
                        <ul {...lsty}>
                            <li>Prototypes</li>
                            <li>CAD designs</li>
                            <li>Large and small installations</li>
                        </ul>
                        <p>
                            Anqua:
                        </p>
                        <ul {...lsty}>
                            <li>Can design, manufacture and install</li>
                            <li>Completes contracted tasks on time and on budget</li>
                            <li>Has a full safety system</li>
                            <li>Has been operating since 1995</li>
                        </ul>
                    </Col>
                </Row>
            </ScrollableAnchor>
            <Row align="center" css={{marginTop: "30px"}}>
                <Col xs={12}>
                    <div css={{width: "100%", overflowX: "hidden"}}>
                        <img src={border2}  {...imageStyle} css={{minWidth: "960px"}}/>
                    </div>
                </Col>
            </Row>
            <Row align="center" css={{marginTop: "30px"}}>
                <Col md={7} xs={12} offset={{md: 5}}>
                    <img src={hex} {...imageStyle} />
                </Col>
            </Row>
            <ScrollableAnchor id="contact">
                <Row align="center" css={{marginTop: "30px", marginBottom: "20px"}}>
                    <Col md={7} xs={12}>
                        <img src={chairs} {...imageStyle} />
                    </Col>
                    <Col md={5} xs={12}>
                        <p>
                            Contact Us
                        </p>
                        <ul {...lsty}>
                            <li>ANQUA</li>
                            <li>A Subsidiary of Macro One Pty Ltd</li>
                            <li>411 Ironbank Road</li>
                            <li>Ironbank SA 5153</li>
                            <li>AUSTRALIA</li>
                        </ul>
                        <p>
                            Enquiries to <Email name="info" domain="anqua.com"/>
                        </p>
                    </Col>
                </Row>
            </ScrollableAnchor>
        </Container>
    );
}



// WEBPACK FOOTER //
// ./src/pages/index.jsx